import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import analytics from "@/utils/analytics";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const lastFired = useRef("");
  useEffect(() => {
    // Emit at the committed route boundary. Titles are deliberately blank,
    // so waiting for a frame would only risk context from a later route.
    if (pathname !== lastFired.current) {
      lastFired.current = pathname;
      analytics.pageView(pathname, "");
    }
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "instant", block: "center" });
      }, 80);
      return () => clearTimeout(timer);
    }
    // ContactPage owns the visual scroll for its product context.
    if (pathname === "/contact" && search.includes("product=")) return;
    const frame = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, search, hash]);
  return null;
}
